import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { MaintenanceCanActivateGuard } from '@app/core/guards/maintenance-can-activate.guard';

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [],
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [],
    },
    {
        path: 'reset-password/:uid/:token',
        component: ResetPasswordComponent,
        canActivate: [],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
